/* ============= Wishlist (Favoriler) ============= */

var WISHLIST_HEART_EMPTY = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none"><path d="M7.98803 12.8426C7.90897 12.8426 7.82988 12.8275 7.75604 12.7966C7.51215 12.6945 1.77217 10.2471 0.851794 5.88868C0.496026 4.20249 0.85329 2.55743 1.80722 1.48907C2.57917 0.623688 3.68896 0.163556 5.01731 0.157384C5.02402 0.157384 5.03073 0.157384 5.0367 0.157384C6.55225 0.157384 7.4764 0.950786 7.9873 1.62622C8.50044 0.948043 9.43195 0.151213 10.9572 0.157384C12.2863 0.163556 13.3969 0.623688 14.1696 1.48907C15.122 2.55674 15.4785 4.20179 15.122 5.88935C14.2031 10.2478 8.46235 12.6959 8.21846 12.7974C8.14612 12.8275 8.06709 12.8426 7.98803 12.8426ZM5.03597 1.1853C5.03149 1.1853 5.02779 1.1853 5.02331 1.1853C4.02537 1.18941 3.2348 1.51101 2.67243 2.14119C1.92733 2.97571 1.65807 4.30328 1.95044 5.69256C2.66272 9.06906 6.93862 11.2634 7.98803 11.7557C9.03743 11.2634 13.3134 9.06906 14.0249 5.69256C14.3187 4.3026 14.0495 2.97502 13.3059 2.14119C12.7435 1.51169 11.9529 1.19077 10.9527 1.18597C10.9483 1.18597 10.9438 1.18597 10.9401 1.18597C9.17094 1.18597 8.54373 2.81595 8.51837 2.88521C8.4408 3.09298 8.22743 3.23422 7.98876 3.23422C7.98726 3.23422 7.9865 3.23422 7.98575 3.23422C7.74634 3.23354 7.53303 3.09297 7.45696 2.88383C7.43235 2.81526 6.80437 1.1853 5.03597 1.1853Z" fill="#4F4632"></path></svg>';
var WISHLIST_HEART_FILLED = '<svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"></path></svg>';

// ============= Cookie Helpers =============
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// ============= Wishlist Helpers =============
function getWishlistHandles() {
    var cookie = getCookie('wishlist');
    if (!cookie || cookie === '') return [];
    return cookie.split('__').filter(function(h) { return h !== ''; });
}

function saveWishlistHandles(handles) {
    if (handles.length === 0) {
        setCookie('wishlist', '', 1);
    } else {
        setCookie('wishlist', handles.join('__'), 1);
    }
}

function updateWishlistCount() {
    var handles = getWishlistHandles();
    var count = handles.length;
    $('.wishcount').text(count);
    $('.headwish a').find('span').text(count);
    $('.wishlist-drawer-count').text(count);

    // Drawer empty/filled state
    if (count === 0) {
        $('.wishlistDrawer .wishlist-empty-state').show();
        $('.wishlistDrawer .mini-wishlist-has-item').hide();
    } else {
        $('.wishlistDrawer .wishlist-empty-state').hide();
        $('.wishlistDrawer .mini-wishlist-has-item').show();
    }
}

function isInWishlist(handle) {
    var handles = getWishlistHandles();
    return handles.indexOf(handle) !== -1;
}

// ============= Mark active hearts on page load =============
function markActiveWishlists() {
    var handles = getWishlistHandles();
    // Product cards
    $('div.wish-lbl-wrp').each(function () {
        var $wrap = $(this);
        var proHandle = $wrap.find(".pro-wishlist input").attr("pro-handle");
        if (proHandle && handles.indexOf(proHandle) !== -1) {
            $wrap.find(".pro-wishlist input").addClass("wishlist_active");
            $wrap.find(".pro-wishlist").addClass("active");
            $wrap.find(".pro-wishlist label .wishlist-label").html(WISHLIST_HEART_FILLED);
        } else {
            $wrap.find(".pro-wishlist input").removeClass("wishlist_active");
            $wrap.find(".pro-wishlist").removeClass("active");
            $wrap.find(".pro-wishlist label .wishlist-label").html(WISHLIST_HEART_EMPTY);
        }
    });
    // Product detail page
    var $pdp = $('.pdp-top-content');
    if ($pdp.length) {
        var pdpHandle = $pdp.find(".pro-wishlist input").attr("pro-handle");
        if (pdpHandle && handles.indexOf(pdpHandle) !== -1) {
            $pdp.find(".pro-wishlist input").addClass("wishlist_active");
            $pdp.find(".pro-wishlist").addClass("active");
            $pdp.find(".pro-wishlist label .wishlist-label").html(WISHLIST_HEART_FILLED);
        } else {
            $pdp.find(".pro-wishlist input").removeClass("wishlist_active");
            $pdp.find(".pro-wishlist").removeClass("active");
            $pdp.find(".pro-wishlist label .wishlist-label").html(WISHLIST_HEART_EMPTY);
        }
    }
}

// ============= Toggle Wishlist (Ekle/Cikar) =============
$(document).on("change", '.pro-wishlist input', function (e) {
    e.stopImmediatePropagation();
    var handle = $(this).attr("pro-handle");
    if (!handle) return;

    var handles = getWishlistHandles();
    var idx = handles.indexOf(handle);

    if (idx === -1) {
        // Ekle
        handles.push(handle);
    } else {
        // Cikar
        handles.splice(idx, 1);
    }

    saveWishlistHandles(handles);
    markActiveWishlists();
    updateWishlistCount();

    // Drawer aciksa, icindeki ilgili urunu de guncelle
    if (idx !== -1) {
        // Cikarildi - drawer'dan da kaldir
        $('.mini-wishlist-item[data-handle="' + handle + '"]').remove();
    }
});

// ============= Drawer Acma/Kapama =============
$(document).on('click', '.wishlist-header a, .main-wishlist', function (e) {
    e.preventDefault();
    $('body').addClass('no-scroll wishlistOpen');
    $('.overlay').addClass('wishlist-overlay');
    loadWishlistDrawer();
});

$(document).on('click', '.closewishlist', function (e) {
    e.preventDefault();
    $('body').removeClass('no-scroll wishlistOpen');
    $('.overlay').removeClass('wishlist-overlay');
});

// Overlay tiklaninca kapat
$(document).on('click', '.overlay.wishlist-overlay', function (e) {
    $('body').removeClass('no-scroll wishlistOpen');
    $('.overlay').removeClass('wishlist-overlay');
});

// ============= Drawer Icerigini Yukle =============
function loadWishlistDrawer() {
    var handles = getWishlistHandles();
    var $scroll = $('.mini-wishlist-scroll');
    $scroll.html('');

    if (handles.length === 0) {
        updateWishlistCount();
        return;
    }

    // Loading goster
    $scroll.html('<div class="wishlist-loading" style="text-align:center;padding:30px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.494 511.494" width="30" height="30" class="spin-animation"><path d="M478.291,255.492c-16.133,0.143-29.689,12.161-31.765,28.16c-15.37,105.014-112.961,177.685-217.975,162.315S50.866,333.006,66.236,227.992S179.197,50.307,284.211,65.677c35.796,5.239,69.386,20.476,96.907,43.959l-24.107,24.107c-8.33,8.332-8.328,21.84,0.004,30.17c4.015,4.014,9.465,6.262,15.142,6.246h97.835c11.782,0,21.333-9.551,21.333-21.333V50.991c-0.003-11.782-9.556-21.331-21.338-21.329c-5.655,0.001-11.079,2.248-15.078,6.246l-28.416,28.416C320.774-29.34,159.141-19.568,65.476,86.152S-18.415,353.505,87.304,447.17s267.353,83.892,361.017-21.828c32.972-37.216,54.381-83.237,61.607-132.431c2.828-17.612-9.157-34.183-26.769-37.011C481.549,255.641,479.922,255.505,478.291,255.492z"/></svg></div>');

    var loaded = 0;
    var total = handles.length;
    var htmlParts = {};

    $.each(handles, function (index, handle) {
        var href = "/products/" + handle + "?view=for_wishlist_drawer";
        $.ajax({
            url: href,
            type: 'GET',
            success: function (data) {
                htmlParts[index] = data;
            },
            error: function () {
                htmlParts[index] = '';
            },
            complete: function () {
                loaded++;
                if (loaded === total) {
                    var finalHtml = '';
                    for (var i = 0; i < total; i++) {
                        if (htmlParts[i]) finalHtml += htmlParts[i];
                    }
                    $scroll.html(finalHtml);
                    updateWishlistCount();
                }
            }
        });
    });
}

// ============= Drawer Icerisinden Urun Cikarma =============
$(document).on('click', '.wishlist-drawer-remove', function (e) {
    e.preventDefault();
    var handle = $(this).attr('data-handle') || $(this).closest('.mini-wishlist-item').attr('data-handle');
    $(this).closest('.mini-wishlist-item').remove();

    var handles = getWishlistHandles();
    handles = handles.filter(function (h) { return h !== handle; });
    saveWishlistHandles(handles);
    updateWishlistCount();
    markActiveWishlists();
});

// ============= Drawer Tumunu Temizle =============
$(document).on('click', '.clear-all-wishlist-drawer', function (e) {
    e.preventDefault();
    setCookie('wishlist', '', 1);
    $('.mini-wishlist-scroll').html('');
    updateWishlistCount();
    markActiveWishlists();
});

// ============= Wishlist Sayfasi Islemleri =============
// Wishlist sayfasindaki urun cikarma
$(document).on('click', '.wishlist-prod-remove', function () {
    $(this).closest(".wishlist-wrap").remove();
    var removeItem = $(this).parents(".wishlist-wrap").attr('data-handle');
    var handles = getWishlistHandles();
    handles = handles.filter(function (h) { return h !== removeItem; });
    saveWishlistHandles(handles);
    updateWishlistCount();
    $('.pro-wishlist-section .wishlist-head h3').find('span').text(handles.length);
});

// Wishlist sayfasindaki tumunu temizle
$(document).on("click", ".pro-wishlist-section .clear-all-wishlist", function (e) {
    e.preventDefault();
    setCookie('wishlist', '', 1);
    $('.pro-wishlist-section .pro-wishlist-wrap .pro-wishlist-scroll').html('');
    $('.pro-wishlist-section .wishlist-head h3').find('span').text('0');
    updateWishlistCount();
    markActiveWishlists();
});

// Wishlist sayfasinda urunleri yukle
var wishlist_page_url = window.location.origin + "/pages/wishlist";
if (window.location.href === wishlist_page_url || window.location.pathname === '/pages/wishlist') {
    var handles = getWishlistHandles();
    if (handles.length > 0) {
        $('.pro-wishlist-section .wishlist-head h3').find('span').text(handles.length);
        var wishlisthtml = '';
        var count = 0;
        $.each(handles, function (index, value) {
            var href = "/products/" + value + "?view=for_wishlist";
            $.ajax({
                url: href,
                type: 'GET',
                success: function (data1) {
                    wishlisthtml += data1;
                },
                complete: function () {
                    count++;
                    if (count === handles.length) {
                        $('.pro-wishlist-section .pro-wishlist-wrap .pro-wishlist-scroll').html(wishlisthtml);
                    }
                }
            });
        });
    }
}

// ============= Sayfa Yuklendiginde =============
$(document).ready(function () {
    markActiveWishlists();
    updateWishlistCount();
});
